import { render, staticRenderFns } from "./OliveOilsAdd.vue?vue&type=template&id=66fa09af&scoped=true"
import script from "./OliveOilsAdd.vue?vue&type=script&lang=js"
export * from "./OliveOilsAdd.vue?vue&type=script&lang=js"
import style0 from "./OliveOilsAdd.vue?vue&type=style&index=0&id=66fa09af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa09af",
  null
  
)

export default component.exports